import { configureStore } from "@reduxjs/toolkit";
import sidebarReducer from "../feature/sidebar/sidebarSlice";
import loginReducer from "../feature/login/loginSlice";
import productReducers from "../feature/products/productSlice";
import addProductReducers from "../feature/products/addProductSlice";
import updateProductReducers from "../feature/products/updateProductSlice";
import deleteProductReducers from "../feature/products/deleteProductSlice";
import transactionReducers from "../feature/transaction/transactionSlice";
import paymentReducers from "../feature/payment/paymentSlice";
import supportReducers from "../feature/support/supportSlice";
import modeReducer from "../feature/modeSlice";
import categoryReducer from "../feature/category/categorySlice";
import addProductMultiImagesReducers from "../feature/products/addProductMultiImagesSlice";
import productDetailReducers from "../feature/products/productDetailSlice";
// import modalReducer from "../feature/modalSlice";

export const store = configureStore({
  reducer: {
    login: loginReducer,
    sidebar: sidebarReducer,
    categories: categoryReducer,
    // modals: modalReducer,
    products: productReducers,
    addProducts: addProductReducers,
    addProductMultiImages: addProductMultiImagesReducers,
    updateProducts: updateProductReducers,
    productDetails: productDetailReducers,
    deleteProducts: deleteProductReducers,
    mode: modeReducer,
    payments: paymentReducers,
    transactions: transactionReducers,
    supports: supportReducers,
  },
});
